<!-- eslint-disable vue/v-on-event-hyphenation -->
<template>
  <div class="widget-body">
    <Swiper
      :id="id"
      class="card-body widget-slider"
      :class="className"
      :slidesPerView="1"
      :spaceBetween="50"
      :autoHeight="autoHeight"
      :allowTouchMove="false"
      :initialSlide="initialSlideIndex"
      :runCallbacksOnInit="false"
      @slideNextTransitionStart="onNextTransitionStart"
      @slidePrevTransitionStart="onPrevTransitionStart"
      @slideNextTransitionEnd="onNextTransitionEnd"
      @slidePrevTransitionEnd="onPrevTransitionEnd"
      @swiper="onSwiperInit"
    >
      <SwiperSlide v-for="(slotName, index) in slotNames" :id="id" :key="index">
        <slot :id="id" :name="slotName"></slot>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  name: 'WidgetBody',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    initialSlideIndex: {
      type: Number,
      default: 0
    },
    onSwiperInitCallback: {
      type: Function,
      default: () => null
    },
    updateSliderIndex: {
      type: Function,
      default: () => null
    },
    viewMode: {
      type: String,
      default: 'default'
    }
  },
  emits: [
    'next-transition-end',
    'prev-transition-end',
    'next-transition-start',
    'prev-transition-start'
  ],
  computed: {
    autoHeight() {
      return this.viewMode !== 'slideshow'
    },
    slotNames() {
      return Object.keys(this.$slots).filter((slot) =>
        slot.startsWith('slide-')
      )
    }
  },
  methods: {
    onSwiperInit(swiper) {
      return this.onSwiperInitCallback(swiper)
    },
    onNextTransitionStart(swiper) {
      this.updateSliderIndex(swiper)
      this.$emit('next-transition-start', swiper)
    },
    onPrevTransitionStart(swiper) {
      this.updateSliderIndex(swiper)
      this.$emit('prev-transition-end', swiper)
    },
    onNextTransitionEnd(swiper) {
      this.$emit('next-transition-end', swiper)
    },
    onPrevTransitionEnd(swiper) {
      this.$emit('prev-transition-end', swiper)
    }
  }
}
</script>

<style lang="scss">
// .widget-body {
//   height: 100% !important;
//   max-height: 90vh !important;
// }
</style>
